module.exports = __webpack_public_path__ + "img/Img.a2cd9856.jpg";